var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIndicator1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.15 22.05c1.3.238 2.587.555 3.85.95V5.904a47.71 47.71 0 0 0-14-1.9 47.71 47.71 0 0 0-14 1.9V23a34.762 34.762 0 0 1 4.667-1.1",
  stroke: "#1BB169",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.722 29c3.375-4 0-8 0-8s-3.375-4 0-8M15.972 29c3.375-4 0-8 0-8s-3.375-4 0-8M21.222 29c3.375-4 0-8 0-8s-3.375-4 0-8",
  stroke: "#1BB169",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})));
export default SvgIndicator1;